import { Table } from '@tanstack/react-table';
import { format } from 'date-fns';
import Papa from 'papaparse';

import { downloadFile } from 'utils/file-download';

interface ExportTableToCsvOptions<T> {
    table: Table<T>;
    exportName: string;
    columnHeader?: (columnId: string) => string;
    onlyVisibleColumns?: boolean;
    excludeDisplayCols?: boolean;
    useSortedRows?: boolean;
}

export const exportTableToCsv = <T>({
    table,
    exportName,
    columnHeader = (id) => id,
    onlyVisibleColumns = false,
    excludeDisplayCols = false,
    useSortedRows = false,
}: ExportTableToCsvOptions<T>) => {
    const columns = (onlyVisibleColumns ? table.getVisibleLeafColumns() : table.getAllLeafColumns()).filter(
        (column) => !excludeDisplayCols || !column.columnDef.meta?.isDisplayCol,
    );
    const rows = (useSortedRows ? table.getSortedRowModel() : table.getFilteredRowModel()).rows;

    const csv = Papa.unparse({
        fields: columns.map((column) => columnHeader(column.id)),
        data: rows.map((row) => columns.map((column) => row.getValue(column.id))),
    });

    downloadFile(
        `${exportName}_table_export_${format(new Date(), 'MM_dd_yyyy')}.csv`,
        window.URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' })),
    );
};
